export const setUserInfo = (userInfo: any, setUserState: any) => {
  try {
    if (userInfo) {
      const dt = userInfo.userInfo;

      const services = userInfo.userService;
      const transformedServices = services.reduce((acc: any, curr: any) => {
        acc[curr.service_id] = curr.stae;
        return acc;
      }, {});

      const transformedRole = services.reduce((acc: any, curr: any) => {
        acc[curr.service_id] = curr.user_role;
        return acc;
      }, {});

      const transformedGroupId = services.reduce((acc: any, curr: any) => {
        acc[curr.service_id] = curr.group_id;
        return acc;
      }, {});

      setUserState((prevState: any) => ({
        ...prevState,
        UserInformation: {
          ...prevState.UserInformation,
          regUserId: dt.reg_user_id,
          userId: dt.user_id,
          user_nm: dt.user_nm,
          regUserName: dt.reg_user_id,
          ctpvNm: dt.ctpv_nm,
          deptNm: dt.dept_nm,
          use_yn: dt.use_yn,
          sso_yn: dt.sso_yn,
          login_type: userInfo.login_type,
        },
        isLogin: true,
        loginTime: Date.now(),
        stae: transformedServices,
        groupId: transformedGroupId,
        userService: transformedRole,
      }));
    }
  } catch (e) {
    console.error('Failed to set user info in localStorage:', e);
  }
};

export const setLogout = (setUserState: any) => {
  setUserState((prevState: any) => ({
    ...prevState,
    UserInformation: {
      regUserId: '',
      regUserName: '',
      user_nm: '',
      userId: '',
      ofcNm: '',
      CompanyID: '',
      CompanyName: '',
      ServiceID: '',
      token: '',
      ctpvNm: '',
      deptNm: '',
    },
    userService: {
      ADMIN: '',
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    stae: {
      ADMIN: '',
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    groupId: {
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    isLogin: false,
    isAdmin: false,
    loginTime: 0,
    currentPage: {
      title: '',
      url: '/',
    },
  }));

  // window.location.replace('/main');
};
